import { FormArray, FormControl, FormGroup } from '@angular/forms';
import {
  BaseNewRequestControlName,
  InvestorDetailsNewRequestFormGroup,
} from '../../../../shared/base-new-request-form/base-new-request-form.model';
import { InvestorDetails } from '../../../../shared/investor-details/investor-details.model';
import {
  ShrubFormGroup,
  TreeFormGroup,
} from '../../../environmental-protection-portal/trees-and-shrubs-felling-request/services/new-request-form/new-request-form.model';

export enum TSRNNewRequestAdditionalControlName {
  Owners = 'owners',
  OwnerOtherThanApplicant = 'ownerOtherThanApplicant',
  Trees = 'trees',
  Shrubs = 'shrubs',
  NonBusinessPurposes = 'nonBusinessPurposes',
}

export const TSRNNewRequestControlName = {
  ...BaseNewRequestControlName,
  ...TSRNNewRequestAdditionalControlName,
};

export interface TSRNNewRequestFormGroup
  extends InvestorDetailsNewRequestFormGroup {
  [TSRNNewRequestControlName.Owners]: FormControl<InvestorDetails[]>;
  [TSRNNewRequestControlName.OwnerOtherThanApplicant]: FormControl<boolean>;
  [TSRNNewRequestControlName.Trees]: FormArray<FormGroup<TreeFormGroup>>;
  [TSRNNewRequestControlName.Shrubs]: FormArray<FormGroup<ShrubFormGroup>>;
  [TSRNNewRequestControlName.NonBusinessPurposes]: FormControl<boolean>;
}
